import { render, staticRenderFns } from "./GetRewardModal.vue?vue&type=template&id=4b6b2212&scoped=true"
import script from "./GetRewardModal.vue?vue&type=script&lang=js"
export * from "./GetRewardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b2212",
  null
  
)

export default component.exports